import { About } from '@widgets/about';
import { Contact } from '@widgets/contact';
import { Footer } from '@widgets/footer';
import { Header } from '@widgets/header';
import { Hero } from '@widgets/hero';
import { ProductShowcase } from '@widgets/products';

export function HomePage() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <About />
        {/* <ProductShowcase /> */}
        <Contact />
      </main>
      <Footer />
    </>
  )
}
